import { render, staticRenderFns } from "./CompetitionCalendarView.vue?vue&type=template&id=d281b2de&scoped=true"
import script from "./CompetitionCalendarView.vue?vue&type=script&lang=ts"
export * from "./CompetitionCalendarView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d281b2de",
  null
  
)

export default component.exports